<template>
    <div>
        <vx-card class="" >
            <vs-col class="w-full" style="margin-bottom: 10px;">
                <img v-if="specialistsCreate.image !== null" :src="specialistsCreate.image.image" alt="" width="200" height="150"/>
                <vs-button @click="activePromptCreate = true" style="margin-top: 10px;width: 200px;">{{$t('choose_cover')}}</vs-button><br>
                <span class="text-danger text-sm" v-if="error_img">{{$t('validation_required')}}</span>
            </vs-col>
            <div class="vx-row w-full mb-6">
                <div class="vx-col w-full" style="padding: 0rem 0rem 0rem 1rem;">
                    <span class="text-base font-medium ">{{ $t("title") }}</span>
                    <vs-input style="margin-top: 10px;border-radius:0px;" class="w-full br-0" v-validate="'required'" name="title" v-model="name"/>
                    <span class="text-danger text-sm" v-show="errors.has('title')">{{ $t('validation_required') }}</span>
                </div>
            </div>
            <div class="vx-row w-full mb-6">
                <div class="vx-col w-full" style="padding: 0rem 0rem 0rem 1rem;">
                    <span class="text-base font-medium "> {{ $t("description") }} </span>
                    <div style="margin-top: 10px;">
                        <div class="vx-row w-full mb-6">
                            <div class="vx-col w-full">
                                <quill-editor
                                    ref="contentEditor"
                                    :options="editorOption"
                                    v-validate="'required'"
                                    name="content"
                                    v-model="text">
                                    <div id="toolbar" slot="toolbar">
                                        <!-- Add a bold button -->
                                        <button class="ql-bold" title="Bold">Bold</button>
                                        <button class="ql-italic" title="Italic">Italic</button>
                                        <button class="ql-underline" title="Underline">underline</button>
                                        <button class="ql-strike" title="Strikethrough">strike</button>
                                        <button class="ql-blockquote" title="Quote"></button>
                                        <button class="ql-code-block" title="Code"></button>
                                        <button class="ql-header" value="1" title="Title 1"></button>
                                        <button class="ql-header" value="2" title="Title 2"></button>

                                        <!--Add list -->
                                        <button class="ql-list" value="ordered" title="Ordered list"></button>
                                        <button class="ql-list" value="bullet" title="Unordered List"></button>

                                        <!-- Add font size dropdown -->
                                        <select class="ql-header" title="Paragraph format">
                                            <option selected>paragraph</option>
                                            <option value="1">Heading 1</option>
                                            <option value="2">Title 2</option>
                                            <option value="3">Heading 3</option>
                                            <option value="4">Heading 4</option>
                                            <option value="5">Title 5</option>
                                            <option value="6">Title 6</option>
                                        </select>
                                        <select class="ql-size" title="font size">
                                            <option value="10px">10px</option>
                                            <option value="12px">12px</option>
                                            <option value="14px">14px</option>
                                            <option value="16px" selected>16px</option>
                                            <option value="18px">18px</option>
                                            <option value="20px">20px</option>
                                        </select>

                                        <!-- Add subscript and superscript buttons -->
                                        <select class="ql-color" value="color" title="font color"></select>
                                        <select class="ql-background" value="background" title="background color"></select>
                                        <select class="ql-align" value="align" title="Align"></select>
                                        <button class="ql-clean" title="reduction"></button>
                                        <button class="ql-link" title="Hyperlinks"></button>
                                        <button class="ql-video" title="Video"></button>

                                        <!-- Custom Buttons -->
                                        <button id="button_image" @click.prevent="filesModalHandler('image')" title="image"><vs-icon icon="add_photo_alternate"></vs-icon></button>
                                        <button id="button_video" @click.prevent="filesModalHandler('video')" title="Video"><vs-icon icon="videocam"></vs-icon></button>
                                        <button id="button_audio" @click.prevent="filesModalHandler('audio')" title="Audio"><vs-icon icon="audiotrack"></vs-icon></button>
                                        <button id="button_doc" @click.prevent="filesModalHandler('doc')" title="Doc"><vs-icon icon="content_paste"></vs-icon></button>

                                        <!-- Edit HTML Button -->
                                        <button id="button_html_edit" title="Edit HTML" class="ql-edit-html"><vs-icon icon="code"></vs-icon></button>
                                    </div>
                                </quill-editor>
                                <span class="text-danger text-sm" v-show="errors.has('content')">{{ $t('validation_required') }}</span>
                            </div>
                        </div>
<!--                        <vs-textarea v-model="text" />-->
                    </div>

                </div>
            </div>


            <div style="padding:20px 0px 30px 0px">
                <span class="text-base font-medium ">
                    {{ $t("upload_the_required_documents") }}
                </span>
                <vs-upload
                    :action="'common/upload/'"
                    @on-success="setImageGalery"
                    @prev-delete="removeFileGalery"
                    :max-size="32"
                    automatic
                    multiple
                    :text="$t('select_a_file')"
                    :fileName="'path'"
                />
            </div>

            <div style="bottom: 10px;left:60px ; position: absolute;">
                <vs-button
                    class="edit_achievement_btn edt_btn lg:mr-3"
                    color="primary"
                    @click="postImageGalery"
                    icon-pack="feather"
                    :automatic="true"
                    :single-upload="true"
                    icon="icon-save"
                    type="filled">
                    {{$t('save')}}
                </vs-button>
            </div>
<!--            <a @click="klick_test()">klick test</a>-->
            <vs-popup
                :title="$t('views')"
                :active.sync="activePromptCreate">
                <ChooseImagePopup style="z-index: 1000000000000;" @save="chooseSpecImage"/>
            </vs-popup>
        </vx-card>
        <vs-popup class="upload_popup" :button-close-hidden="uploadPopupButton" :title="uploadPopupTitle" :active.sync="filesPopup">
            <vs-row>
                <vs-col vs-offset="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <label for="files_input" class="files_input_button vs-component vs-button vs-button-primary vs-button-filled includeIcon">
                        <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-upload null" style="order: 0; margin-right: 5px; margin-left: 0px;"></i>
                        <span class="vs-button-text vs-button--text">{{$t('select_file')}}</span>
                    </label>
                    <input type="file" id="files_input" class="files_input" :accept="this.accept" multiple ref="files" v-on:change="handleFileUpload()"/>
                </vs-col>
            </vs-row>
        </vs-popup>
    </div>
</template>

<script>
import DescriptionsMixin from './DescriptionsMixin.vue'
import ChooseImagePopup from './ChooseImagePopup.vue'
import CycleMixin from "../RegistrationOfDisciplines/components/DisList/CycleMixin";
export default {
    data () {
        return {
            toolbar: '#toolbar',
            data:[],
            text:'',
            name:null,
            files:[],
            modal:false,
            ChooseImagePopupData: {
                active: false,
                data: null,
            },
            specialistsCreate: {
                name: "",
                name_ru: "",
                name_en: "",
                name_kk: "",
                image: null,
            },
            data_img:[],
            error_img:false,
            activePromptCreate:false,
        }
    },
    mixins:[DescriptionsMixin],
    props: {
    },
    components: {
        ChooseImagePopup
    },
    created() {
        // await this.$http.get('/common/reference_guide/').then((res) => {
        //     this.data = res.data;
        //     this.text = this.data.description
        //     this.name = this.data.name
        // });
        this.dgdg()
    },
    watch:{
    },
    methods: {
        async dgdg(){
            let files_upload = [this.data]
            this.files = files_upload.map(
                ({file})=>{
                    return{...file, firstFiles: true,response: file}
                }
            )
        },

        // klick_test(){
        //     console.log(this.specialistsCreate.image)
        // },
        chooseSpecImage(image) {
            this.specialistsCreate.image = image.image;
            this.error_img = false
            this.data_img = image
            this.closeImagePopup();
        },
        closeImagePopup() {
            this.activePromptCreate = false;
        },
        successUpload(){
            this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
        },
        setImageGalery(response) {
            // this.dataNewNews.image = response[0].uid;
            // console.log("resposne IMages", response);
            this.uploadImages = []
            response.forEach((item) => {
                this.uploadImages.push(item.uid)
            });
        },
        async removeFileGalery({ file, done }) {
            this.files = await this.files.filter(
                (item) => {item.uid !== file.uid}
            );
            done();
        },
        async postImageGalery() {

            if (this.specialistsCreate.image == null){
                this.error_img = true
            }
            this.$validator.validateAll().then(async result => {
                if (result&&!this.error_img) {
                    this.$vs.loading();
                    const res = await this.$http.post(
                        `/common/reference_guide_post/`,
                        { file: this.uploadImages ,description:this.text,name:this.name,img:this.specialistsCreate.image.uid}
                    );
                    if (res.status === 200) {
                        this.galeryImages = res.data.gallery_files;
                        this.$vs.notify({
                            title: this.$t("succesful"),
                            text: this.$t("image_added"),
                            color: "primary",
                        });
                        this.trueUpload = false;
                        setTimeout(() => {
                            this.trueUpload = true;
                        }, 300);
                        this.activeAddGalery = false;
                        // window.location.reload();
                    }
                    this.$vs.loading.close();
                    this.$router.go(0);
                }
            })

        },
    },
}
</script>

<style lang="scss">
.bug_complete,
.take_to_work{
    position: relative;
    .con-vs-loading{
        position: absolute;
        background: transparent;
    }
}
</style>

<style lang="scss" scoped>
.file_bugs_item{
    &:not(:last-child){
        margin-bottom: 10px;
    }
    img{
        max-width: 100%;
        border: 1px solid #cccccc;
    }
}
</style>
